import { useState } from 'react'
import { login } from '../../../../api/auth'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setAuthenticated } from '../../../../store/actions/authActions'
import { ROUTES } from '../../../../router/routes'
import { useToast } from '../../../ui'

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.\[\]{}\(\)?\-“!@#%&\/,><\’:;|_~`])\S{8,99}$/

const useSignIn = (setErrors) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const toast = useToast()

    const [signInUser, setSignInUser] = useState({ email: '', password: '' })
    const [isLoading, setIsLoading] = useState(false)

    const handleSignInInputChange = (fieldName, value) => {
        setSignInUser((prevState) => ({
            ...prevState,
            [fieldName]: value,
        }))
    }

    const resetSignInForm = () => {
        setSignInUser({ email: '', password: '' })
    }

    const validateSignIn = () => {
        if (!signInUser.email || !emailRegex.test(signInUser.email)) {
            setErrors((prevState) => ({
                ...prevState,
                email: 'Please enter a valid business email',
            }))
            return false
        } else {
            setErrors((prevState) => ({
                ...prevState,
                email: '',
            }))
        }
        if (!signInUser.password || !passwordRegex.test(signInUser.password)) {
            setErrors((prevState) => ({
                ...prevState,
                password: 'Please enter a valid business email',
            }))
            return false
        } else {
            setErrors((prevState) => ({
                ...prevState,
                password: '',
            }))
        }
        return true
    }

    const handleSignIn = () => {
        if (validateSignIn()) {
            setIsLoading(true)
            login({
                username: signInUser.email,
                password: signInUser.password,
            })
                .then((res) => {
                    resetSignInForm()
                    dispatch(setAuthenticated(true, res))
                    // record user login in db
                    const body = {
                        action: 'login',
                        userID: res.username,
                        isDev: process.env.REACT_APP_SCOOP_ENV === 'dev',
                    }
                    fetch(
                        'https://pig8gecvvk.execute-api.us-west-2.amazonaws.com/corsair/ui_information',
                        {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${res.signInUserSession.idToken.jwtToken}`,
                            },
                            body: JSON.stringify(body),
                        }
                    )
                        .then((response) => {
                            if (!response.ok) {
                                throw new Error('Network response was not ok')
                            }
                            return response.json() // Or handle the response in the way you need if you care about it
                        })
                        .catch((error) => {
                            console.error('Error recording login', error)
                        })

                    navigate(ROUTES.INSIGHTS)
                })
                .catch((error) => {
                    toast.error(error.message)
                })
                .finally(() => {
                    setIsLoading(false)
                })
        }
    }

    return {
        signInUser,
        handleSignInInputChange,
        handleSignIn,
        isSignInLoading: isLoading,
    }
}

export default useSignIn
